<script setup lang="ts">
const { org } = useContext()
const { t } = useI18n()
useSeoMeta({
  title: t('Home'),
})
</script>

<template>
  <PageInner>
    <PageTitleWithBreadcrumbs
      :title="$t('Home')"
    />
    <Message v-if="org.announcement && org.announcement !== ''">
      {{ org.announcement }}
    </Message>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card
        v-if="org.introduction && org.introduction !== ''"
        class="md:col-span-2"
      >
        <template #content>
          <div
            class="max-w-prose"
            v-html="org.introduction"
          />
        </template>
      </Card>
      <Card>
        <template #title>
          {{ $t('News') }}
        </template>
        <template #content>
          <NewsList :paginate="false" />
        </template>
      </Card>
      <DashboardThisWeeksMatches />
    </div>
  </PageInner>
</template>
